import { render, staticRenderFns } from "./Registrations.vue?vue&type=template&id=5dd87e89&scoped=true&"
import script from "./Registrations.vue?vue&type=script&lang=js&"
export * from "./Registrations.vue?vue&type=script&lang=js&"
import style0 from "./Registrations.vue?vue&type=style&index=0&id=5dd87e89&lang=scss&scoped=true&"
import style1 from "./Registrations.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd87e89",
  null
  
)

export default component.exports